import { ref, onMounted, computed, defineComponent, getCurrentInstance, useContext, useCssModule, } from '@nuxtjs/composition-api';
import { useAudio } from '~/composables';
import { useDuck } from '~/services';
import { cachePage, createHead, humanizeSeconds, useAsyncRef } from '~/utils';
import { PODCASTS_PARTNERS } from '~/components/PodcastPartner';
import { EDUCATIONS_PODCASTS } from '~/constants';
const duck = useDuck();
export default defineComponent({
    name: 'PagePodcastEpisode',
    setup() {
        /**
         * Composables.
         */
        const context = useContext();
        const css = useCssModule();
        const viewport = context.$viewport;
        /**
         * Instance.
         */
        const instance = getCurrentInstance();
        const podcast = useAsyncRef(instance, 'podcast');
        const isEducation = computed(() => {
            return EDUCATIONS_PODCASTS.includes(context.route.value.params.podcast);
        });
        const entries = computed(() => {
            const { date, serial = {} } = podcast.value || {};
            const { issue, name, url } = serial || {};
            const items = [
                {
                    title: 'Подкасты',
                    to: '/podcasts',
                },
            ];
            if (name && url) {
                items.push({
                    title: name,
                    to: `/${url}`,
                });
            }
            if (issue) {
                items.push(`Выпуск ${issue}`);
            }
            if (date) {
                items.push(Intl.DateTimeFormat('ru').format(podcast.value.date));
            }
            if (isEducation.value) {
                items.unshift({
                    title: 'Forbes Education',
                    to: '/education/',
                });
            }
            return items;
        });
        const subscribeButtonSize = computed(() => {
            return viewport.isLessThan('tablet') ? 'default' : 'small';
        });
        /**
         * Audio.
         */
        const audio = ref({});
        /**
         * Component key.
         */
        const componentKey = ref(0);
        function playPause() {
            audio.value?.playPause();
            const event = new CustomEvent('playPause', {
                detail: podcast.value,
            });
            window.dispatchEvent(event);
        }
        onMounted(() => {
            const podcast = instance.data.podcast;
            audio.value = useAudio(podcast?.file?.uri || '');
            audio.value.on('update', () => {
                componentKey.value += 1;
            });
        });
        return {
            audio,
            componentKey,
            css,
            entries,
            podcast,
            subscribeButtonSize,
            humanizeSeconds,
            playPause,
        };
    },
    async asyncData(context) {
        const { app, env, error, req, res, route } = context;
        try {
            const routePath = route.path.replace(/^\/|\/$/g, '');
            let podcastItem;
            if (routePath.startsWith('preview')) {
                const { data } = await duck.pub.getPubPreviewToken(routePath.replace('preview/', ''));
                podcastItem = data;
            }
            else {
                const { data } = await duck.pub.getPubGeneral({
                    url: route.path.replace(/^\/|\/$/g, ''),
                });
                podcastItem = data.data;
            }
            const podcast = {
                body: podcastItem.body || [],
                date: Number(podcastItem.time) * 1000,
                description: podcastItem.subtitle,
                file: podcastItem.podcast_file,
                image: podcastItem.photo,
                isPartner: podcastItem.url_alias.replace(/\/\d+.+/g, '') in PODCASTS_PARTNERS(),
                key: podcastItem.issue,
                serial: podcastItem.serial || {},
                title: podcastItem.title,
                url: podcastItem.url_alias,
            };
            let description = `${podcast.title} – слушайте подкаст «${podcast.title}»  на Forbes.ru`;
            if (podcast.description) {
                description = podcast.description.slice(0, 250);
            }
            const title = `${podcast.title} | Подкасты Forbes.ru`;
            const head = {
                canonical: env.HOST + route.path,
                description,
                image: (podcast.image || {}).uri || '',
                title,
                url: env.HOST + route.path,
            };
            context.$page = app.$page = {
                title,
            };
            if (process.server) {
                cachePage({ date: podcast.date, req, res });
            }
            return {
                $page: context.$page,
                head,
                podcast,
            };
        }
        catch (e) {
            console.error(e);
            error({ statusCode: 404 });
        }
    },
    head() {
        return createHead(this.head, { shouldUseTitleTemplate: false });
    },
});
